import { PageStatus } from 'enums/page.enum';
export const DEFAULT_PAGE_STATUS = PageStatus.DRAFT;
